import { SortingConfiguration, CouponButtonPosition } from "../../../Typings";
export const cmsConfig = {
    numberOfTopLeagues: 5,
    numberOfAllLeaguesShownByDefault: 5,
    showTopLeaguesList: true,
    sortingLogic: SortingConfiguration.Alphabetically,
    sportsExcludedFromAlphabeticalSorting: ["2", "5"],
    isCouponCreationEnabled: true,
    maxCouponLeagues: 5,
    couponButtonPosition: CouponButtonPosition.Fixed,
    showCouponButtonBottom: false,
    regionId: "6",
    sortIPTopLeaguesFirst: true
};
//# sourceMappingURL=config.js.map